// Copyright (C) 2021 Bystronic Laser AG
/* eslint-disable no-console */

import environment from '@/utils/environment';

export class Logger {
  public static error(message?: any, ...optionalParams: any[]) {
    if (!environment.isProductionEnvironment()) {
      console.error(message, ...optionalParams);
    }
  }

  public static warn(message?: any, ...optionalParams: any[]) {
    if (!environment.isProductionEnvironment()) {
      console.warn(message, ...optionalParams);
    }
  }

  public static info(message?: any, ...optionalParams: any[]) {
    if (!environment.isProductionEnvironment()) {
      console.info(message, ...optionalParams);
    }
  }
}
